<template>
  <div class="container">
    <el-dialog
      :visible.sync="visible"
      center
      width="80%"
      @close="handleDialogClose"
      @opened="handleDialogOpened">
      <el-form @submit.native.prevent :model="sendForm" :rules="sendRules" ref="refSendForm">
        <el-form-item>
          <img style="width: 80px; height: 50px;" src="@/assets/expressage.png"/>
        </el-form-item>
        <el-form-item prop="expressageNo">
          <el-input
            ref="refExpressageNo"
            autocomplete="off"
            clearable
            maxlength="64"
            v-model.trim="sendForm.expressageNo"
            :placeholder="$t('common.expressageNo')"
            @keyup.enter.native="handleEnterExpressageNo">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="send" type="text" size="small" style="font-size: 20px; color: #4889ED;">
          {{$t('common.finish')}}
        </el-button>
      </span>
    </el-dialog>
    <el-form @submit.native.prevent :inline="true" :model="form" :rules="rules" ref="refForm">
      <el-form-item prop="productOrderNo">
        <el-input
          ref="refProductOrderNo"
          autocomplete="off"
          clearable
          maxlength="64"
          v-model.trim="form.productOrderNo"
          @clear="reset"
          :placeholder="$t('common.productOrderNo')"
          @keyup.enter.native="handleEnterProductOrderNo">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="text" size="medium" @click="query">
          {{$t('common.query')}}
        </el-button>
      </el-form-item>
    </el-form>
    <div class="deliver-order-text">
      代发货单
      <div class="separator"/>
    </div>
    <ul class="infinite-list" v-infinite-scroll="load" style="overflow:auto;">
      <li v-for="(item, index) in listData" :key="item.id" class="infinite-list-item">
        <tpProdProductOrder :data="item" @click="onClickProductOrder" :index="index"/>
      </li>
    </ul>
  </div>
</template>

<script>
import { tporderList, addExpressageNo } from '@/api/tpProdOrder';
import { storeStatus } from '@/utils/defines';
import tpProdProductOrder from './tpProdProductOrder';

export default {
  name: 'ScanningExpress',
  components: {
    tpProdProductOrder,
  },
  data() {
    return {
      form: {
        productOrderNo: undefined,
      },
      rules: {
      },
      sendForm: {
        expressageNo: undefined,
      },
      sendRules: {
        expressageNo: [{ required: true, trigger: 'submit', message: this.$t('validate.expressageNoCanNotBeEmpty') }],
      },
      page: 1,
      perpage: 20,
      totalCount: 0,
      listData: [],
      visible: false,
      productOrderNo: undefined,
      sendIndex: -1,
    };
  },
  mounted() {
    this.tporderList();
    this.$refs.refProductOrderNo && this.$refs.refProductOrderNo.focus();
    this.scanBoxInfoBarCode();
  },
  methods: {
    handleEnterExpressageNo() {
      this.send();
    },
    handleEnterProductOrderNo() {
      this.query();
    },
    query() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          this.listData = [];
          this.tporderList();
        }
      });
    },
    reset() {
      this.page = 1;
      this.listData = [];
      this.tporderList();
    },
    send() {
      this.$refs.refSendForm.validate((valid) => {
        if (valid) {
          this.addExpressageNo();
        }
      });
    },
    async tporderList() {
      try {
        const {
          productOrderNo,
        } = this.form;
        const res = await tporderList({
          page: this.page,
          perpage: this.perpage,
          productOrderNo: productOrderNo || undefined,
          status: storeStatus.send.val,
        });
        const { data } = res;
        if (data.count !== undefined) {
          this.totalCount = data.count;
        }
        if (this.page === 1) {
          this.listData = data.records;
        } else {
          this.listData = this.listData.concat(data.records);
        }
      } catch (e) {
        // do nothing.
      }
    },
    async addExpressageNo() {
      const { productOrderNo } = this;
      const {
        expressageNo,
      } = this.sendForm;
      try {
        await addExpressageNo({ productOrderNo, expressageNo });
        this.$message({
          type: 'success',
          message: this.$t('common.scanSuccess'),
        });
        this.sendForm.expressageNo = undefined;
        const index = this.sendIndex;
        if (index !== -1) {
          this.listData.splice(index, 1);
        }
        this.visible = false;
      } catch (e) {
        // do nothing.
      }
    },
    load() {
      if (this.listData.length === 0 || this.listData.length >= this.totalCount) {
        return;
      }
      this.page += 1;
      this.tporderList();
    },
    onClickProductOrder(data, index) {
      this.productOrderNo = data.productOrderNo;
      this.sendIndex = index;
      this.visible = true;
    },
    handleDialogClose() {
      if (this.$refs.refSendForm && typeof this.$refs.refSendForm.resetFields === 'function') {
        this.$refs.refSendForm.resetFields();
      }
    },
    handleDialogOpened() {
      this.$refs.refExpressageNo && this.$refs.refExpressageNo.focus();
    },
    scanBoxInfoBarCode() {
      let code = '';
      let nextCode;
      document.onkeypress = (e) => {
        nextCode = e.which;
        if (nextCode !== 13) {
          code += String.fromCharCode(nextCode);
        }
        if (nextCode === 13) {
          if (this.visible) {
            if (this.$refs.refExpressageNo && this.$refs.refExpressageNo.focused) {
            } else {
              this.sendForm.expressageNo = code;
              this.send();
            }
          } else if (this.$refs.refProductOrderNo && this.$refs.refProductOrderNo.focused) {
          } else {
            this.form.productOrderNo = code;
            this.query();
          }
          code = '';
        }
      };
    },
  },
};
</script>

<style scoped>
  .container {
    height: 100%;
  }
  .el-form {
    text-align: center;
    margin: 10px auto 0;
  }
  .deliver-order-text {
    color: #1F232E;
    font-size: 17px;
    padding: 0 15px;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #DDDDDD;
    display: block;
    margin: 10px 0;
  }
</style>
